import { useEffect, useState } from 'react';

import { executeQuery } from 'common/gql';
import { toGQLLocale } from 'common/gql/utils/gql-locale';
import { useLocalization } from 'common/providers/LocaleProvider';
import brandsGlossary from '../gql/query/brandsGlossary.gql';
import type { BrandsGlossaryResponse, BrandsGlossaryVariables, BrandsSection } from './types';

export const useBrandsGlossary = () => {
  const { locale } = useLocalization();
  const [isLoading, setIsLoading] = useState(false);
  const [brandsSections, setBrandsSections] = useState<BrandsSection[]>(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const variables = {
          locale: toGQLLocale(locale),
        };
        const {
          brandsGlossary: { sections },
        } = await executeQuery<BrandsGlossaryResponse, BrandsGlossaryVariables>(
          brandsGlossary,
          variables
        );

        setBrandsSections(sections);
      } catch {
        setBrandsSections(null);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [locale]);

  return [brandsSections, isLoading] as const;
};
